var map = {
	"./1/symbol_0.png": "a617",
	"./1/symbol_1.png": "5ea6",
	"./1/symbol_10.png": "0b5e",
	"./1/symbol_11.png": "6713",
	"./1/symbol_12.png": "aa31",
	"./1/symbol_2.png": "c7b29",
	"./1/symbol_3.png": "a7f7",
	"./1/symbol_4.png": "c2e5",
	"./1/symbol_5.png": "1bd0",
	"./1/symbol_6.png": "467d",
	"./1/symbol_7.png": "6cf3",
	"./1/symbol_8.png": "16cd",
	"./1/symbol_9.png": "6353",
	"./2/symbol_0.png": "fb0a",
	"./2/symbol_1.png": "3fbf",
	"./2/symbol_10.png": "022f",
	"./2/symbol_11.png": "9d30",
	"./2/symbol_12.png": "83ce",
	"./2/symbol_2.png": "50ad",
	"./2/symbol_3.png": "169b",
	"./2/symbol_4.png": "a8b7",
	"./2/symbol_5.png": "36c5",
	"./2/symbol_6.png": "e19e",
	"./2/symbol_7.png": "1b6d",
	"./2/symbol_8.png": "c9b2",
	"./2/symbol_9.png": "ca88",
	"./3/symbol_0.png": "44fc",
	"./3/symbol_1.png": "f21e",
	"./3/symbol_10.png": "88c3",
	"./3/symbol_12.png": "5948",
	"./3/symbol_2.png": "72a29",
	"./3/symbol_3.png": "02d0a",
	"./3/symbol_4.png": "8df1",
	"./3/symbol_5.png": "5d75",
	"./3/symbol_6.png": "b8c4",
	"./3/symbol_7.png": "e5f6",
	"./3/symbol_8.png": "393e",
	"./3/symbol_9.png": "e276",
	"./4/symbol_0.png": "6f1f",
	"./4/symbol_1.png": "0d52",
	"./4/symbol_10.png": "050f",
	"./4/symbol_12.png": "b87f",
	"./4/symbol_2.png": "ddf8",
	"./4/symbol_3.png": "7e4b",
	"./4/symbol_4.png": "b756",
	"./4/symbol_5.png": "08f9",
	"./4/symbol_6.png": "2a2f",
	"./4/symbol_7.png": "2cb0",
	"./4/symbol_8.png": "bd7b4",
	"./4/symbol_9.png": "642d",
	"./gold1.png": "ac08",
	"./gold2.png": "bfcf",
	"./gold3.png": "c73e",
	"./gold4.png": "7618",
	"./header_slotmachine_freespin._no_fg.png": "1608",
	"./silver1.png": "092d",
	"./silver2.png": "3e75",
	"./silver3.png": "263d",
	"./silver4.png": "4019",
	"./slotmachine.png": "49cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b242";